export const messages = {
  en: {
    printQuestionAnswer: {
      table: {
        name: 'Name',
        type: 'Type',
        options: 'Options',
        selectCount: 'Select Count'
      },
      type: {
        single: 'Single Choice',
        multiple: 'Multiple Choice',
        shortAnswer: 'Short Answer'
      },
      label: {
        total: 'Total',
        submitted: 'Submitted'
      },
      unit: {
        person: 'person(s)'
      }
    }
  },
  zh: {
    printQuestionAnswer: {
      table: {
        name: '名称',
        type: '类型',
        options: '选项',
        selectCount: '选择人数'
      },
      type: {
        single: '单选',
        multiple: '多选',
        shortAnswer: '简答'
      },
      label: {
        total: '总数',
        submitted: '已提交'
      },
      unit: {
        person: '人'
      }
    }
  },
  'zh-TW': {
    printQuestionAnswer: {
      table: {
        name: '名稱',
        type: '類型',
        options: '選項',
        selectCount: '選擇人數'
      },
      type: {
        single: '單選',
        multiple: '多選',
        shortAnswer: '簡答'
      },
      label: {
        total: '總數',
        submitted: '已提交'
      },
      unit: {
        person: '人'
      }
    }
  }
}
